var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('router-link',{class:_vm.anchorClass,attrs:{"to":_vm.anchorLink}},[_c('img',{staticStyle:{"max-width":"182px","margin-left":"22px"},attrs:{"src":"https://online.jsil.com/javax.faces.resource/JsilLogoo.jpg.xhtml?ln=images","alt":"","srcset":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }